import { useRef, useEffect, useState } from "react";

/**
 * Legacy tilt hook — kept for API compatibility with existing components.
 * The 3D perspective transform has been permanently DISABLED because it
 * promotes the target element (and any text inside) to a GPU compositing
 * layer, which causes a subtle "shimmer / blur" during page scroll on
 * Retina and Windows high-DPI displays. Returned handlers are no-ops.
 */
export function useTilt(intensity = 8) {
    const ref = useRef(null);
    const [enabled] = useState(false);

    useEffect(() => {}, []);

    const onMouseMove = () => {};
    const onMouseLeave = () => {};

    return { ref, onMouseMove, onMouseLeave };
}
